import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=3102bc7c"
import script from "./goodsdetail.vue?vue&type=script&lang=js"
export * from "./goodsdetail.vue?vue&type=script&lang=js"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&id=3102bc7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports